<template>
  <header class="section-header">
    <div class="first-line">{{first}}</div>
    <h2 class="second-line">{{second}}</h2>
    <!-- Start third line with description -->
    <div class="third-line">{{third}}</div>
  </header>
</template>

<script>
export default {
  props: {
    first: {
      type: String,
      default: 'Title',
    },
    second: {
      type: String,
      default: 'Subtitle',
    },
    third: {
      type: String,
      default: 'Description',
    },
  },

};
</script>

<style lang="scss" scoped>
//Functions

.section-header{
    width:100%;
    margin-top:calc(var(--base)*0);
    margin-bottom:calc(var(--base)*4);
    letter-spacing: -0.02em;
    @media (min-width: 768px) {
        margin-top:calc(var(--base)*15);
        margin-bottom:calc(var(--base)*6);
    }
    @media (min-width: 1024px) {
        margin-top:calc(var(--base)*0);
        margin-bottom:calc(var(--base)*4);
    }
    .first-line{
        font-size: calc(var(--base) * 2);
        line-height: calc(var(--base) * 3);
        font-weight: 300;
        color:#363636;
    }
    .second-line{
        margin:0;
        padding:0;
        font-size:calc(var(--base) * 3);
        line-height: 1;
        font-weight: 500;
        color:#262626;
    }
    // Start third line with description
    .third-line{
        font-size: calc(var(--base) * 1.5);
        line-height: calc(var(--base) * 2);
        font-weight: 300;
        color:#363636;
        margin: calc(var(--base) * 2) 0 0 0;
        padding: 0;
        // italics
        font-style: italic;
    }
}
</style>
